import { IWidgetType } from '../IWidgetType';
import { WidgetCategory, WidgetType } from '../Widget';

export const WidgetSelectFilters = {
  /**
   * Nelle celle della tabella possono essere inseriti solo widget di tipo Input,
   * Computed, Paragraph oppure il widget di "Servizio Esterno", a differenza delle colonne in cui non
   * è possibile inserire widget di tipo Paragraph.
   */
  TableCell: (widget: IWidgetType<any>) =>
    widget.category === WidgetCategory.Input ||
    widget.category === WidgetCategory.Computed ||
    widget.type === WidgetType.Paragraph ||
    widget.type === WidgetType.AsyncSelect,
  /**
   * Widget "inline" che possono essere inseriti nelle colonne della tabella.
   */
  TableColumn: (widget: IWidgetType<any>) =>
    widget.category === WidgetCategory.Input ||
    widget.category === WidgetCategory.Computed ||
    widget.type === WidgetType.Paragraph,
};
